module.exports = __webpack_public_path__ + "media/images/background_offer-1440w-d806b4ab.jpg";